export default __webpack_public_path__ + "static/media/favicon.cdc31723.ico";